import { Link } from "react-router";
import type { GroupDetail } from "@/lib/groups/group-detail";
import type { GroupMemberItem } from "@/lib/groups/group-member-item";
import type { GroupExpenseItem } from "@/lib/groups/group-expense-item";
import type { GroupInviteItem } from "@/lib/groups/group-invite-item";
import { GroupProfileView } from "@/components/groups/group-profile-view";
import { GroupActionsBar } from "@/components/groups/group-actions-bar";
import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { load } from "../api/load";
import { seg } from "../api/respond";

type Data = {
  group: GroupDetail;
  members: GroupMemberItem[];
  recentExpenses: GroupExpenseItem[];
  inviteLinks: GroupInviteItem[];
};

export function loader({ params }: LoaderFunctionArgs) {
  return load<Data>(`/api/v1/admin/groups/${seg(params.id!)}`);
}

export default function GroupDetailPage() {
  const { group, members, recentExpenses, inviteLinks } = useLoaderData() as Data;
  const now = new Date();

  return (
    <div className="flex flex-col gap-6">
      <nav className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[13px] text-fc-text-secondary">
          <Link to="/admin" className="text-fc-text-dim hover:text-fc-text">
            Home
          </Link>
          <span className="text-fc-text-dim">/</span>
          <Link
            to="/admin/groups"
            className="text-fc-text-dim hover:text-fc-text"
          >
            Groups
          </Link>
          <span className="text-fc-text-dim">/</span>
          <span className="font-medium text-fc-text">{group.name}</span>
        </div>
        <Link
          to="/admin/groups"
          className="inline-flex items-center gap-2 rounded-md border border-fc-border bg-fc-overlay px-3 py-1.5 text-[12.5px] text-fc-text hover:border-fc-brand"
        >
          ← Back to list
        </Link>
      </nav>

      <GroupActionsBar
        groupId={group.id}
        inviteLinkCount={group.inviteLinkCount}
      />

      <GroupProfileView
        group={group}
        now={now}
        members={members}
        recentExpenses={recentExpenses}
        inviteLinks={inviteLinks}
      />
    </div>
  );
}
